import { ReactElement, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
// import ReactSwitch from 'react-switch';
import { toast } from 'react-toastify';
// import type { AxiosError } from 'axios';
import { useNavigate } from 'react-router-dom';
import Button from '../../controls/Button';
import { registerUser } from '../../services/dashboard-service';
import CustomInputBox from '../../controls/CustomInputBox';
import parsePasswordValidationMap from '../../_helpers/passwordValidation';
import { INDUSTRIES, RHFValidations } from '../../constants/global-constants';
import PasswordInputBox from '../../controls/PasswordInputBox';
import CustomDropdown from '../../controls/CustomDropdown';

type FORMDATA = {
  firstName: string;
  lastName: string;
  password: string;
  confirmPassword: string;
  orgName: string;
  email: string;
};

/**
 * User details component for Account Activation.
 * @returns - Recat component for UserDetails.
 */
export default function UserDetailsComponent(): ReactElement {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const methods = useForm<FORMDATA>({
    mode: 'all'
  });
  const { handleSubmit, watch } = methods;

  // const [remberMe, setRemeberMe] = useState(true);
  /**
   * Handles the activate action when the form is submitted.
   * @param  data - The form submit event.
   */
  const activateUser = async (data: FORMDATA): Promise<void> => {
    try {
      setLoading(true);
      await registerUser(data);
      setLoading(false);
      toast.success('Registered successfully');
      navigate(`/auth/verify-otp?email=${encodeURIComponent(data.email)}`);
    } catch (e) {
      setLoading(false);
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };
  const confirmPasswordValidation = parsePasswordValidationMap(
    'confirm password',
    watch('password')
  );

  return (
    <div className="flex flex-col gap-8 w-full">
      <div className="dark:bg-container-700 bg-white p-6 rounded w-full">
        <div className="text-xl dark:text-white text-black font-semibold flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            type="button"
            className="material-icons-outlined text-gray-400 text-[1rem]"
          >
            arrow_back
          </button>
          Activate your Account
        </div>
        <div className="text-gray-400 mt-1">Please enter your details to setup our account</div>
        {/* eslint-disable-next-line */}
        <FormProvider {...methods}>
          <form noValidate className="mt-4" action="post" onSubmit={handleSubmit(activateUser)}>
            <div className="flex gap-3">
              <CustomInputBox
                label="First Name"
                idname="firstName"
                type="text"
                autoComplete="given-name"
                validationObject={{ required: 'First name is required' }}
              />
              <CustomInputBox
                label="Last Name"
                idname="lastName"
                type="text"
                autoComplete="family-name"
                validationObject={{ required: 'Last name is required' }}
              />
            </div>
            <CustomInputBox
              label="Organization Name"
              idname="orgName"
              type="text"
              autoComplete="off"
              validationObject={{ required: 'Organization name is required' }}
            />
            <CustomInputBox
              label="Email ID"
              idname="email"
              type="email"
              autoComplete="email"
              validationObject={RHFValidations.emailRequired}
            />
            <CustomDropdown
              label="Industry"
              validationObject={{ required: 'Industry is required' }}
              // validationObject={{ required: 'Please select an industry' }}
              id="industry"
              options={INDUSTRIES.map((industry) => ({ value: industry, label: industry }))}
            />
            <PasswordInputBox
              label="Password"
              idname="password"
              autoComplete="new-password"
              validationObject={RHFValidations.password}
            />
            <PasswordInputBox
              label="Confirm Password"
              idname="confirmPassword"
              autoComplete="off"
              validationObject={confirmPasswordValidation}
            />
            {/* <div className="flex items-center justify-between mt-8">
            <div className="flex items-start">
              <div className="flex items-center h-5">
                <ReactSwitch
                  width={36}
                  height={20}
                  onChange={(checked) => setRemeberMe(checked)}
                  checked={remberMe}
                  uncheckedIcon={false}
                  onColor="#2970FF"
                  checkedIcon={false}
                  handleDiameter={16}
                />
              </div>
              <div className="ml-3 text-sm">
                <h1 className="text-gray-500 text-sm font-medium">Remember me</h1>
              </div>
            </div>
          </div> */}
            <div className="mt-12 w-full">
              <Button
                isBlockButton
                buttonType="submit"
                loading={loading}
                theme="primary"
                size="sm"
                name="Activate Account"
              />
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
}
